import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

import {
  AppointmentDetailsResponse,
  OutstandingBalancesResponse,
  PatientInsuranceSearchRequest,
  PatientInsuranceSearchResponse,
} from '../models/appointment-details.models';

@Injectable({
  providedIn: 'root',
})
export class AppointmentDetailsService {
  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  /**
   * Fetch appointment details by confirmation code
   * GET /appointments/me/{confirmationCode}/find
   * Returns raw API response without mapping
   */
  getAppointmentDetails(
    confirmationCode: string
  ): Observable<AppointmentDetailsResponse> {
    const baseUrl = this.environmentService.appointmentSchedulingBaseUrl;
    const url = `${baseUrl}me/${confirmationCode}/find`;

    return this.http.get<AppointmentDetailsResponse>(url);
  }

  /**
   * Fetch outstanding balances for a patient
   * Calls Patient Portal API /guest/invoicesForPerson
   * GET /guest/invoicesForPerson?firstName={firstName}&lastName={lastName}&dateOfBirth={dateOfBirth}&zipCode={zipCode}
   */
  getOutstandingBalances(
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    zipCode: string
  ): Observable<OutstandingBalancesResponse> {
    const url = `${this.environmentService.baseUrl}/guest/invoicesForPerson`;

    const headers = new HttpHeaders({
      'x-client-type': 'patient',
    });

    const params = new HttpParams()
      .set('firstName', firstName)
      .set('lastName', lastName)
      .set('dateOfBirth', dateOfBirth)
      .set('zipCode', zipCode);

    return this.http.get<OutstandingBalancesResponse>(url, {
      headers,
      params,
    });
  }

  /**
   * Search patient insurances by LPID
   * POST /appointments/patients/insurances/search
   */
  searchPatientInsurances(
    request: PatientInsuranceSearchRequest
  ): Observable<PatientInsuranceSearchResponse> {
    const baseUrl = this.environmentService.appointmentSchedulingBaseUrl;
    const url = `${baseUrl}me/insurances/search`;

    const headers = new HttpHeaders({
      'x-client-type': 'patient',
    });

    return this.http.post<PatientInsuranceSearchResponse>(url, request, {
      headers,
    });
  }
}
